
























































































// vendor
import { defineComponent, computed, ref, PropType, watch, SetupContext } from "@vue/composition-api";
// project
import { Dictionary } from "@/utils/types";
import { Asset } from "@/psychlab/types";
import { getAssetTypes } from "@/psychlab/meta";
import { IconCardGrid } from "@/components.generic/icon-card-grid";
import { pascalToSentenceCase } from "@/utils/text";
import { useAssetListDisplay } from "@/hooks/useAssetListDisplay";
import { useAssets } from "@/hooks/useAssets";
import { useUserPrefs } from "@/hooks/useUserPrefs";
import { useTags } from "@/hooks/useTags";
import * as AppModal from "@/AppModal";
// local
import { default as Sort } from "./sort.vue";
import * as Utils from "./utils";
import {
	Divider,
	Pagination,
	Date as DateLabel,
	AbsBox,
	RouteButton,
	ContextOption
} from "@ui";

import { useTranslate } from "@lang";


const AssetTypes:any = {};
getAssetTypes().forEach(t => AssetTypes[t.name] = t);

const typeColors:any = {
	"Form":"#9471fe",
	"Graph":"#117a8b",
	"CognitiveTest":"#00bdd6"
};

const sortFn:Dictionary<((a:Asset, b:Asset) => number)|undefined> = {
	"name":(b, a) => {
		return b.name.localeCompare(a.name);
	},
	"lastModified":(b, a) => {
		return (new Date(a.lastModified || "")).getTime() - (new Date(b.lastModified || "")).getTime()
	}
};

const createAsset = (type:string, context:SetupContext) => {
	const assetHooks = useAssets();
	const tagHooks = useTags();
	AppModal.createAsset({ type }, async (r) => {
		const { name, tags, openEditor } = r;
		const a = await assetHooks.createAsset(type, name);
		await Promise.all(tags.map(t => tagHooks.tagItem(t, a._id, "asset")));
		if(openEditor){
			context.root.$router.push({
				name:"asset.edit",
				params:{
					assetId:a._id,
				}
			})
		}
	});
};

export default defineComponent({
	emits:[
		"click-add"
	],
	props:{
		taggingEnabled:{
			type:Boolean,
			default:true
		},
		showContext:{
			type:Boolean,
			default:true
		},
		showAdd:{
			type:Boolean,
			default:true
		},
		defaultTag:{
			type:String,
		},
		exclude:{
			type:Array as PropType<string[]>,
			default:() => []
		},
		include:{
			type:Array as PropType<string[]>,
			default:() => []
		},
		contextFn:{
			type:Function as PropType<(a:Asset) => ContextOption[]>,
			default:() => [],
		},
		searchFilter:{
			type:String,
			default:"",
		},
	},
	components:{
		IconCardGrid,
		Sort,
		Pagination,
		Divider,
		DateLabel,
		AbsBox,
		RouteButton,
	},
	setup(props, context){
		const sortProperty = ref(Utils.getQueryValue("ag_sort", context, "lastModified"));

		watch(sortProperty, (v) => {
			Utils.setQueryValue("ag_sort", v, context);
		});

		const { hasTag } = useTags();

		const assetHooks = useAssets();

		const activeTag = computed(() => props.defaultTag || null);

		const {
			openAssetContext,
			pagination,
			getAssetTags,
		} = useAssetListDisplay({
			activeTag,
			context,
			queryPrefix:"ag",
			contextFn:props.contextFn,
		});

		const { translate } = useTranslate();

		const { assetGridLimit } = useUserPrefs();

		pagination.limit = assetGridLimit.value;

		watch(() => pagination.limit, () => assetGridLimit.value = pagination.limit);

		const assets = computed(() => {
			const tagged = assetHooks.assets.value.filter(a => (props.defaultTag ? hasTag(props.defaultTag, a._id) : true));
			return tagged.filter(a => displayTypes.value.includes(a.type))
		});

		const displayTypes = computed(() => {
			if(props.include.length > 0){
				return props.include;
			}
			return Object.keys(AssetTypes).filter(t => !props.exclude.includes(t));
		});

		const sortOptions = computed(() => {
			return [
				{ value: "name", text: "Name" },
				{ value: "lastModified", text: "Modified" },
			]
		});

		const filterAsset = (a:Asset) => {
			if(!props.searchFilter || props.searchFilter.length < 2){ return true; }
			return a.name.toLowerCase().includes(props.searchFilter.toLowerCase());
		};

		const sortedAssets = computed(() => {
			const cp = assets.value.filter(filterAsset);

			const fn = sortFn[sortProperty.value];
			if(fn){
				cp.sort(fn);
			}
			return cp;
		});
		
		const displayAssets = computed(() => {
			const i = (pagination.page - 1) * pagination.limit;
			let e = i + pagination.limit;
			if(e >= pagination.total){
				e = pagination.total;
			}
			return sortedAssets.value.slice(i, e);
		});

		watch(() => sortedAssets.value.length, v => {
			pagination.total = v;
		})

		pagination.total = sortedAssets.value.length;

		const addColor = computed(() => {
			if(displayTypes.value.length === 1){
				return getTypeColor(displayTypes.value[0]);
			}
			return "white";
		});

		const openContext = (event:any, asset:Asset) => {
			openAssetContext(event, asset._id);
		};

		const getAssetTagArgs = (asset:Asset) => {
			return {
				type:"asset",
				item:asset._id
			};
		};

		const addType = (type:string) => {
			// const typeNameAlias = ({
			// 	"Graph":"Blueprint"
			// } as any);
			
			
			// const n = translate(`assets.label.new${typeNameAlias[type] || type}`);
			
			// // const name = pascalToSentenceCase(typeNameAlias[type] || type);
			// AppModal.editText({
			// 	value: n,
			// 	title: n,
			// 	validator(v){
			// 		return v.length > 2;
			// 	}
			// }, async (v:string) => {
			// 	assetHooks.createAsset(type, v, props.defaultTag);
			// });
			createAsset(type, context);
		};

		const addAsset = (e:any) => {
			if(!displayTypes.value.length){ return; }

			if(displayTypes.value.length === 1){
				addType(displayTypes.value[0]);
				return;
			}
			const options:any[] = displayTypes.value.map(t => {
				return {
					name:pascalToSentenceCase(t),
					icon:getTypeIcon(t),
					fn: ()=> {
						addType(t);
					}
				}
			});
			AppModal.context(e, options);
		};

		const getTypeIcon = (type:string) => AssetTypes[type].icon || "mdi.circle-outline";

		const getTypeColor = (type:string) => typeColors[type] || "white";

		const getAssetRoute = (asset:Asset) => {
			const query:any = { ...context.root.$route.query };
			return {
				name:'view-asset', 
				params:{
					assetId:asset._id,
				},
				query
			}
		};

		return {
			addColor,
			displayAssets,
			pagination,
			sortedAssets,
			sortProperty,
			sortOptions,
			openContext,
			addAsset,
			getAssetTagArgs,
			getAssetRoute,
			getTypeIcon,
			getTypeColor,
			getAssetTags,
		};
	}
});

